function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { memo } from "react";
import styled, { css } from "styled-components";
import stack from "../../../helpers/stack";
import { transparentizedPrimaryColor } from "../../../helpers/transparentize";
import { defaultColor, primaryColor, dividerColor } from "../../../helpers/color";
const Root = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Root",
  componentId: "sc-1ta7x2b-0"
})(["", " position:relative;height:16px;width:38px;border-radius:16px;background-color:", ";"], stack, dividerColor));
const Handle = /*#__PURE__*/memo(styled.div.withConfig({
  displayName: "Handle",
  componentId: "sc-1ta7x2b-1"
})(["position:absolute;width:16px;height:16px;border-radius:100%;background-color:", ";opacity:0.5;transition:0.2s ease-in-out;transition-property:background-color,transform;&::before{content:\"\";position:absolute;top:-10px;left:-10px;right:-10px;bottom:-10px;}&::after{content:\"\";position:absolute;top:-6px;left:-6px;width:28px;height:28px;border-radius:100%;background-color:", ";opacity:0;transform:scale(0.5);transition:transform 0.2s ease-in-out;transition-property:opacity,transform;}", " ", ""], primaryColor, transparentizedPrimaryColor, ({
  disabled
}) => !disabled && css(["opacity:1;cursor:pointer;&:hover{background-color:", ";}&:hover::after{opacity:1;transform:scale(1);}"], primaryColor), ({
  active
}) => active ? css(["transform:translateX(22px);background-color:", ";"], primaryColor) : css(["background-color:", ";"], defaultColor)));
const Switch = /*#__PURE__*/memo(({
  value,
  onClick,
  ...props
}) => {
  return /*#__PURE__*/React.createElement(Root, _extends({
    onClick: onClick
  }, props), /*#__PURE__*/React.createElement(Handle, {
    active: !!value,
    disabled: !onClick
  }));
});
Switch.displayName = "Switch";
export default Switch;
//# sourceMappingURL=index.js.map